import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import { colors } from "../../data/colors";
import { calendarModalStyles } from "../../data/styles/modalStyles";
import { stdObject } from "../../data/types/stdObject";
import Header from "../componentModal/Header";
import useCalendarModal from "./useCalendarModal";
import Calendar from "../../screens/MainStructure/components/Calendar/Calendar";
import MiniCalendar from "./MiniCalendar";
import BasicButton from "../BasicButton";
import { getCurrentMonth } from "../../utils/getCurrentMonth";
import { useMainContext } from "../../context/MainContext";

export default function CalendarModal({
  open = false,
  close = () => {},
}: {
  open: boolean;
  close: () => void;
}) {
  const {
    selected,
    selectDay,
    selectedWeek,
    selectWeek,
    secondFlex,
    calendarDays,
    isBigScreen,
    isMediumcreen,
    isVertical,
    squareButtons,
    currentMonth,
    setCurrentMonth,
    calendarView,
    changeCalendarView,
  } = useCalendarModal({
    open,
    close,
  });
  const { t } = useTranslation();
  const { calDocsList } = useMainContext();
  return (
    <Modal isOpen={open} onRequestClose={() => {}} style={calendarModalStyles}>
      <div className="documentContainer">
        <Header
          title={""}
          mainColor={colors.blue}
          squareInputs={[
            {
              type: "month",
              value: currentMonth,
              active: true,
              innerStyle: { width: "auto" },
              onChange: (e: stdObject) => {
                let value =
                  e.target.value === ""
                    ? getCurrentMonth()
                        .map((e: number, index: number) =>
                          index > 0 && e < 10 ? "0" + e : e,
                        )
                        .join("-")
                    : e.target.value;
                setCurrentMonth(value);
                selectDay("");
              },
            },
          ]}
          squareButtons={squareButtons}
          date={""}
        />
        <div
          className="calendarModalBody"
          style={{ flexDirection: isVertical ? "column" : "row" }}
        >
          <div
            className="miniCalendarPanel"
            style={{
              display: "flex",
              flexDirection: "column",
              width: isVertical ? "100%" : 220,
              height: isVertical ? "auto" : "100%",
              maxHeight: isVertical ? 280 : "none",
              borderBottom: isVertical ? `solid 2px ${colors.blue}` : "none",
              borderRight: isVertical ? "none" : `solid 2px ${colors.blue}`,
              flexShrink: 0,
              overflow: "hidden",
            }}
          >
            <div className="buttonsBar">
              <BasicButton
                type="mini"
                title={t("p.dayView")}
                color={calendarView === "day" ? colors.blue : colors.darkGrey}
                onClick={() => changeCalendarView("day")}
              />
              <BasicButton
                type="mini"
                title={t("p.week")}
                color={calendarView === "week" ? colors.blue : colors.darkGrey}
                onClick={() => changeCalendarView("week")}
              />
              <BasicButton
                type="mini"
                title={t("p.monthView")}
                color={calendarView === "month" ? colors.blue : colors.darkGrey}
                onClick={() => changeCalendarView("month")}
              />
            </div>
            <MiniCalendar
              calendarDays={calendarDays}
              calDocsList={calDocsList}
              selected={selected}
              calendarView={calendarView}
              setSelected={selectDay}
              selectedWeek={selectedWeek}
              selectWeek={selectWeek}
            />
          </div>
          <Calendar
            params={{
              selected,
              setSelected: selectDay,
              selectedWeek,
              calendarView,
              secondFlex,
              calendarDays,
              isBigScreen,
              isMediumcreen,
            }}
          />
        </div>
      </div>
    </Modal>
  );
}
